document.addEventListener("DOMContentLoaded", function () {

  const modalOverlay = document.getElementById("modal-overlay");
  const closeButton = document.getElementById("close-button");
  const form = document.getElementById("phone-form");
  const phoneSelect = document.getElementById("phone-select");
  const currentPath = window.location.pathname;

  // Function to set a permanent cookie
  function setCookie(name, value, days) {
    //return true;
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  }

  // Function to get a cookie value by name
  function getCookie(name) {
    const cookieArray = document.cookie.split("; ");
    for (const cookie of cookieArray) {
      const [cookieName, cookieValue] = cookie.split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  function closePopup() {
    modalOverlay.classList.add("fade-out"); // Add the fade-out class
    //setTimeout(() => popup.remove(), 300); // Wait for the animation to complete before removing
  }  

  // Check for the "modalShown" cookie
  if (getCookie("modalShown") || currentPath === "/pages/wholesale") {
    modalOverlay.style.display = "none";
    return; // Exit if the cookie exists
  }

  // Close modal when the close button is clicked
  closeButton.addEventListener("click", function () {
    setCookie("modalShown", "true", 365); // Set cookie to prevent modal from displaying
    //modalOverlay.style.display = "none";
    closePopup();
  });

  // Handle form submission
  form.addEventListener("submit", function (event) {
    event.preventDefault(); // Prevent form submission
    const selectedValue = phoneSelect.value;

    if (!selectedValue) {
      alert("Please select a phone model to proceed.");
      return;
    }

    // Send event to Google Tag Manager
    /*
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "popup_submission",
        popup_category: "Popup",
        popupSelection: selectedValue,
      });
    }
    */
    
    //Send event to gtag
    gtag("event", "popup_submission", { "popup_selection": selectedValue });

    // Set cookie to prevent modal from displaying again
    setCookie("modalShown", "true", 365);

    logSelection(selectedValue);

    // Close the modal
    //modalOverlay.style.display = "none";
    closePopup();
  });
  
});

function logSelection(v) {

  const remoteUrl = "https://www.sortinosoft.com/phoneModel.php";
  const callbackName = "handleResponse";

  const script = document.createElement("script");

  script.src = `${remoteUrl}?value=${encodeURIComponent(v)}&callback=${callbackName}`;

  window[callbackName] = function (response) {
    console.log("Response from server:", response);

    document.body.removeChild(script);

    delete window[callbackName];
  };

  document.body.appendChild(script);
}
